import PropTypes from 'prop-types';
import MatchAccaSelectionItemImpl from './match-acca-selection-item.js';
import MojitoCore from 'mojito/core';

const { UIView } = MojitoCore.Presentation;

/**
 * Match acca selection info for leg in a single bet.
 *
 * @class MatchAccaSelectionItem
 * @memberof Mojito.Presentation.Modules
 */

/**
 * MatchAccaSelectionItem component prop types.
 *
 * @property {string} selectionLabel - Selection label to be shown.
 * @property {string} [marketName] - Market name to be shown.
 * @property {string} [eventName] - Event name to be shown.
 * @property {boolean} showSeparator - If true a separator will be shown under the icon.
 * @property {boolean} [isSuspended=false] - Will render suspended label if true.
 * @property {object} [earlyPayout] - Early Payout object.
 * @property {string} [allowSelectionRemoval=false] - Will render remove selection button if true.
 * @property {string} [voidReason] - Void reason.
 * @property {string} [selectionId] - Selection id for the removal leg of a Bet Builder bet.
 * @property {boolean} [isRedundant] - If true a selection is redundant.
 * @property {string} [status] - Settlement status of the selection (e.g., OPEN, WON, LOST, VOID).
 *
 * @memberof Mojito.Presentation.Modules.MatchAccaSelectionItem
 */
const propTypes = {
    selectionLabel: PropTypes.string.isRequired,
    marketName: PropTypes.string,
    eventName: PropTypes.string,
    showSeparator: PropTypes.bool.isRequired,
    isSuspended: PropTypes.bool,
    earlyPayout: PropTypes.object,
    allowSelectionRemoval: PropTypes.bool,
    voidReason: PropTypes.string,
    selectionId: PropTypes.string,
    isRedundant: PropTypes.bool,
    status: PropTypes.string,
};

const defaultProps = {
    isSuspended: false,
    allowSelectionRemoval: false,
};

export default UIView(
    'MatchAccaSelectionItem',
    MatchAccaSelectionItemImpl,
    propTypes,
    defaultProps
);
